<template>
<!-- 更换其他信息 -->
  <div>
    <el-dialog
      :title="$t('pages.equipment.text161')"
      :visible.sync="otherVisible"
      width="650px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <div class="tips">
          {{ $t("pages.equipment.text162") }}
        </div>
        <el-form ref="form" label-width="auto" class="demo-ruleForm">
          <el-form-item :label="$t('button.downloadTemplate')">
            <DiluButton
              type="export"
              @click="importTemplate"
              :title="$t('button.downloadTemplate')"
            ></DiluButton>
            <span>{{ $t("pages.equipment.text61") }}</span>
          </el-form-item>
          <el-form-item :label="$t('pages.equipment.text63')">
            <DiluButton
              type="import"
              @click="equipmentImport"
              :title="$t('pages.equipment.text63')"
              :fileList="fileList"
            ></DiluButton>
            <span>{{ $t("pages.equipment.text62") }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" :loading="loading" @click="submit">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
export default {
  data() {
    return {
      params: {
        url: "",
      },
      loading: false,
      fileList: [],
    };
  },
  components: {
    DiluButton,
  },
  props: ["otherVisible"],
  methods: {
    //取消
    handleClose() {
      this.params = {
        url: "",
      };
      this.fileList = [];
      this.$emit("closeOther");
    },
    //下载模版
    importTemplate() {
      this.request.importDevicetemplate().then();
    },
    //选择Excel上传
    equipmentImport(e) {
      this.params.url = e;
    },
    //确定
    submit() {
      let that= this;
      if (!this.params.url) {
        return this.$message.error(that.$t("pages.equipment.text63"));
      }
      this.loading = true;
      this.request.equipmentListEdit(this.params).then((res) => {
        let str = `${that.$t("pages.equipment.text163")}${res.data.successSize} ${that.$t(
          "pages.equipment.text164"
        )}，${that.$t("pages.equipment.text165")}${res.data.failSize} ${that.$t(
          "pages.equipment.text164"
        )}`;
        this.$message.success(str);
        this.$emit("equipmentList");
        this.handleClose();
         this.loading = false;
      });
    },
  },
};
</script>


<style scoped>
.demo-ruleForm {
  margin-top: 20px;
}
.tips {
  margin-left: 20px;
}
</style>